<template>
  <div v-if="isShow" class="card-success-box">
    <pb-card class="box-card">
      <div class="card-title">
        <i class="pb-icon-success" style="color: green; font-size: 17px" />
        <span class="card-title-tip">{{ $t('Gattaran_Feedback__NySC' /** 反馈提交成功 */) }}</span>
      </div>
      <div class="card-content">
        {{
          $t(
            'Gattaran_Feedback__qGnl',
            {
              pm_name: chargeUser,
            } /** 反馈已提交给产品接口人 */,
          )
        }}
        <br />
        {{
          $t(
            'Gattaran_Feedback__zikb',
            /** 您可以通过【我的反馈】列表了解问题反馈的处理进展 */
          )
        }}
      </div>
      <pb-button type="primary" class="card-btn" @click="doClose">{{ $t('Gattaran_Feedback__UgYW' /** 我知道了 */) }}</pb-button>
    </pb-card>
  </div>
</template>

<script>
export default {
  props: {
    chargeUser: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isShow: false,
    };
  },
  methods: {
    doClose() {
      this.isShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.card-success-box {
  width: 100vw;
  height: 100vh;
  position: absolute;
  background-color: rgba(40, 43, 51, 0.5);
  top: 0;
  right: 0;
  z-index: 999;
}
.box-card {
  position: absolute;
  top: 60px;
  right: 157px;
  width: 384px;
  top: 30%;
  left: 36%;
}
.card-title {
  margin-left: 6px;
  margin-bottom: 16px;
}
.card-title-tip {
  margin-left: 6px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #282b33;
  letter-spacing: 0;
  line-height: 24px;
  font-weight: 500;
}
.card-content {
  margin-left: 4px;
  margin-bottom: 24px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #595c66;
  line-height: 22px;
  font-weight: 400;
}
.card-btn {
  float: right;
  margin-bottom: 24px;
}

:deep(.pb-card) {
  overflow: visible;
}
</style>
